import { Directive, ElementRef, effect, inject, input } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[abxAriaDisabled]',
})
export class AriaDisabledDirective {
  readonly abxAriaDisabled = input<boolean>(false);

  private readonly el = inject(ElementRef<HTMLElement>);

  /** Original tabindex value present on the host element before this directive
   *  ever mutates it. `null` means the attribute was absent. */
  private readonly originalTabindex: string | null;

  constructor() {
    // Capture BEFORE any effect runs so the first effect run can restore correctly.
    this.originalTabindex = this.el.nativeElement.getAttribute('tabindex');

    effect(() => {
      const disabled = this.abxAriaDisabled();
      const nativeEl = this.el.nativeElement;
      nativeEl.setAttribute('aria-disabled', String(disabled));
      if (disabled) {
        nativeEl.setAttribute('tabindex', '-1');
        nativeEl.classList.add('is-disabled');
      } else {
        // Restore the original tabindex rather than unconditionally removing it,
        // so a host with tabindex="0" in the template keeps its focusability.
        if (this.originalTabindex !== null) {
          nativeEl.setAttribute('tabindex', this.originalTabindex);
        } else {
          nativeEl.removeAttribute('tabindex');
        }
        nativeEl.classList.remove('is-disabled');
      }
    });
  }
}
